import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AgeVerificationProvider, AgeVerificationModal } from './context/AgeVerificationContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import PageTransition from './components/PageTransition';
import { registerServiceWorker } from './serviceWorkerRegistration';
import './arkora.css';
import './styles/immersive.css';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Philosophy = lazy(() => import('./pages/Philosophy'));
const Global = lazy(() => import('./pages/Global'));
const Contact = lazy(() => import('./pages/Contact'));
const Legal = lazy(() => import('./pages/Legal'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

// Loading fallback
const PageLoader = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bg-primary)'
  }}>
    <div className="image-placeholder" style={{
      width: '60px',
      height: '60px',
      borderRadius: '50%'
    }} />
  </div>
);

// Layout wrapper to conditionally show nav/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  
  return (
    <div className="App">
      {!isAdmin && <Navigation />}
      <main>
        <PageTransition>
          {children}
        </PageTransition>
      </main>
      {!isAdmin && <Footer />}
      <AgeVerificationModal />
      {!isAdmin && <CookieConsent />}
    </div>
  );
};

function App() {
  // Register service worker on mount
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <ThemeProvider>
      <AgeVerificationProvider>
        <BrowserRouter>
          <Layout>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/philosophy" element={<Philosophy />} />
                <Route path="/global" element={<Global />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Suspense>
          </Layout>
        </BrowserRouter>
      </AgeVerificationProvider>
    </ThemeProvider>
  );
}

export default App;
